import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { registerServiceWorker } from "./notifications";

// Register service worker for offline mode + push notifications
registerServiceWorker();

// One-time migration: lessons curriculum was restructured (Day 1-2 → Day 1-12).
// Bump existing users' currentDay by +10 if they were past the old Day 2.
(function migrateCurriculumV2() {
  const FLAG = "curriculumV2Migrated";
  if (localStorage.getItem(FLAG)) return;
  const oldDay = Number(localStorage.getItem("currentDay") || 1);
  if (oldDay >= 3) {
    localStorage.setItem("currentDay", String(oldDay + 10));
  }
  localStorage.setItem(FLAG, "1");
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
